module.exports = __webpack_public_path__ + "img/icon-arrow-gray.46fbe644.svg";